import React, { Suspense } from 'react';
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  Scripts,
} from '@tanstack/react-router';
import Navigation from '../components/Navigation/Navigation';
import type { IRouterWithAuthContext } from '../types/auth/authContext';

const TanStackRouterDevtools =
  import.meta.env.VITE_ENVIRONMENT === 'local'
    ? React.lazy(() =>
        import('@tanstack/react-router-devtools').then(res => ({
          default: res.TanStackRouterDevtools,
        }))
      )
    : () => null; // Render nothing in production

export const Route = createRootRouteWithContext<IRouterWithAuthContext>()({
  component: () => (
    <>
      <HeadContent />
      <Navigation />
      <Outlet />
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
      <Scripts />
    </>
  ),
  head: () => ({
    meta: [
      {
        title: 'Ingle Lewer',
      },
    ],
  }),
});
